
import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    title1: '以科技推动全球教育发展',
    title2: '',
    subTitle: '20 多年的值得信赖 | 以科技创新赋能教育',
    legacyEvolutionTitle: '我们的传承，我们的发展',
    legacyEvolutionDesc1: '20 多年来，{brand} 一直是海外留学申请和服务业值得信赖的领导者。我们最初的使命是简化全球教育之旅，如今我们已成为一家具有前瞻性思维的教育科技 (EdTech) 公司，致力于重新定义代理商、学校和学生的国际教育体验。 ',
    legacyEvolutionDesc2: '凭借数十年的行业经验，我们识别并解决了全球教育领域的痛点，将传统服务转变为更快、更智能、更个性化的技术驱动解决方案。 ',
    ecosystemTitle: '我们的核心生态系',
    ecosystemDesc: '我们建立了一个多元化、整合性的教育平台，涵盖海外学习之旅的每个阶段，确保代理、学校和学生的学习过程零中断、零延误。 ',
    ecosystemType1: '代理',
    ecosystemTypeDesc1: 'B2B代理平台，代理微信小程序',
    ecosystemType2: '学校',
    ecosystemTypeDesc2: 'B2B2C品牌平台，教学辅助平台',
    ecosystemType3: '学生',
    ecosystemTypeDesc3: '学生平台、住宿、保险、学习中心',
    whyPartner1: '为何选择与 ',
    whyPartner2: '{brand} 合作',
    whyPartner3: '?',
    reasonTitle1: '>20 多年的信赖',
    reasonDesc1: '我们了解全球教育产业的各个层面，并拥有为代理、学校和学生解决实际问题的良好记录。 ',
    reasonTitle2: '技术驱动的效率',
    reasonDesc2: '人工智慧自动化、全天候支援和整合平台可为您节省时间、降低成本并最大限度地减少错误。 ',
    reasonTitle3: '端对端支援',
    reasonDesc3: '从申请到抵达（以及之后），我们涵盖旅程的每一步——无需与多家供应商合作。 ',
    majorSysTitle1: '主要系统:',
    majorSysTitle2: '协助无缝运营',
    majorSysDesc: '我们的核心系统旨在简化工作流程、减少人工工作量并确保营运平稳运行——无论您正在管理内部流程或支援客户。 ',
    majorSys1: 'BMS - 内部 ERP 系统',
    majorSysFunc1: '端对端业务管理',
    majorSysFuncDesc1: '将销售、申请、客户资料和营运到一个直观的平台。 ',
    majorSysFuncFeature11: '集中式客户和应用程式追踪',
    majorSysFuncFeature12: '自动化工作流程管理',
    majorSysFuncFeature13: '即时报告与分析',
    majorSysFuncFeature14: '无缝团队协作',
    majorSys2: 'GEAR - B2B 代理门户',
    majorSysDesc2: '专为提高代理工作效率而构建，使用 AI 驱动的工具来减少耗时的任务。 ',
    majorSysFuncFeature21: '即时业务概览',
    majorSysFuncFeatureDesc21: '造访仪表板，即时追踪申请进度、佣金状态和客户更新。 ',
    majorSysFuncFeature22: '人工智慧驱动的应用程式自动化',
    majorSysFuncFeatureDesc22: '自动化文件检查、表单填写和审核工作流程，加快申请周转速度。 ',
    majorSysFuncFeature23: '即时机构与课程查询',
    majorSysFuncFeatureDesc23: '搜寻全球学校和课程的综合资料库，在几分钟内为学生匹配理想的选择。 ',
    majorSysFuncFeature24: '线上佣金结算',
    majorSysFuncFeatureDesc24: '提交佣金请求、收集数位签章并更快收到付款－不再需要文书工作或延迟。 ',
    majorSys31: '{brand} Assistance 取得帮助 - ',
    majorSys32: '微信代理小程式',
    majorSysDesc3: '即使在旅途中也能保持联系并高效工作：',
    majorSysFuncFeature31: '随时随地取得资源：透过微信，随时随地取得海外学习指南、特定国家/地区的申请流程和准备清单。 ',
    majorSysFuncFeature32: 'AI 课程匹配：根据学生的成绩、兴趣和预算，透过行动装置为他们推荐量身定制的课程。 ',
    majorSysFuncFeature33: '主要优势：无论您身在何处，都不会错过任何客户机会或重要更新。 ',
    majorSys4: 'B2B2C 网站：学校和代理商的品牌解决方案',
    majorSysDesc4: '我们创建客制化的白标入口网站，让您展示您的品牌，同时利用我们强大的技术来推动招生。 ',
    majorSysFuncFeature41: '学校品牌入口网站',
    majorSysFuncFeatureDesc41: '完全可自订的平台，重点介绍海外学习项目，为学生和家长提供无缝体验。强化品牌形象，简化国际项目申请。 ',
    majorSysFuncFeature42: '代理品牌入口网站',
    majorSysFuncFeatureDesc42: '以您自己的品牌展示服务、合作机构和成功案例。从竞争对手中脱颖而出，建立信任，并简化服务交付。 ',
    platformTitle: '专业平台：超越应用程式',
    platformDesc: '我们的解决方案透过创新的学习技术来支持学生的学业成功和机构的教学目标。 ',
    platformFeature1: '线上课程学校 (OSSD)',
    platformFeatureDesc1: '经认证的安大略省中学文凭课程，面向全球学生，时间安排灵活。帮助学生无需搬迁即可满足国际学术要求。 ',
    platformFeature2: 'AI 教学辅助平台',
    platformFeatureDesc2: '全天候 AI 机器人提供即时教学辅助－解答问题、批改作业和强化概念。提升参与度，改善学习成果',
    miniAppTitle: '以学生为中心的小程式',
    miniAppDesc: '我们优先考虑学生在国外的舒适度和成功率，并透过小程式处理这些“琐事”，让他们能够专注于学业。 ',
    miniAppApp1: '学习中心',
    miniAppAppDesc1: '一站式机场接送、学校注册、银行帐户设定和紧急援助服务。可自订的套餐可消除安顿压力。 ',
    miniAppApp2: '游学',
    miniAppAppDesc2: '短期课程让学生在入学前体验海外生活。减轻焦虑，增强信心，并帮助做出明智的决定。 ',
    miniAppApp3: '电子视讯证明',
    miniAppAppDesc3: '安全的影片证明，确认申请状态、录取通知书和入学情况。消除诈欺风险，让您安心无忧。 ',
    learnMore: '了解更多',
    contactUs: '联系我们',
    companyName: '环球教育科技',
    companyName1:'国际教育联盟',
    companyAddress: '香港科学园白石角一期2W大厦5楼502室',
    companyAddress2:'广东省广州市天河区林和东路285号中汇人寿中心8楼',
    companyPhone: '852-2110-3835',
    companyPhone2:'+86 20 87564591',
  },
  route,
  message,
  ...layout,
};
